export default __webpack_public_path__ + "static/media/Guidelines for Starting Therapy.f5080ec9.pdf";